import * as z from 'zod';
export const tCreateProfileSchema = z.object({
    title: z.string().min(1, { message: 'Please enter new title' }),
    description: z.string().transform(value => value || ''),
    isDefault: z.boolean()
});
export const tProfileSettingsSchema = tCreateProfileSchema.extend({
    id: z.string()
});
